export interface PremiumFeature {
  name: string;
  free: string | number;
  playerPlus: string | number;
  playerUnlimited: string | number;
  icon?: string;
  highlight?: boolean;
}

export interface PremiumTier {
  name: string;
  color: string;
  price?: string;
  description?: string;
}

export const PREMIUM_TIERS: PremiumTier[] = [
  {
    name: "Free",
    color: "#9E9E9E", // Gray
    description: "Basic features for all players",
  },
  {
    name: "Player +",
    color: "#FFC107", // Gold/Yellow
    price: "$9.99/month",
    description: "Enhanced gameplay experience",
  },
  {
    name: "Player Unlimited",
    color: "#E91E63", // Pink/Magenta
    price: "$19.99/month",
    description: "Ultimate premium experience",
  },
];

export const PREMIUM_FEATURES: PremiumFeature[] = [
  {
    name: "Clicks per minute",
    free: 10,
    playerPlus: 25,
    playerUnlimited: "Unlimited",
  },
  {
    name: "Worth",
    free: "Standard",
    playerPlus: "5% Boost",
    playerUnlimited: "15% Boost",
  },
  {
    name: "Profile Avatar",
    free: "Default",
    playerPlus: "AI Video",
    playerUnlimited: "AI Video",
  },
  {
    name: "Profile description",
    free: "No",
    playerPlus: "Yes",
    playerUnlimited: "Yes",
  },
  {
    name: "Profile background",
    free: "Default",
    playerPlus: "Default",
    playerUnlimited: "Custom Upload",
  },
  {
    name: "Custom avatar",
    free: "No",
    playerPlus: "No",
    playerUnlimited: "Custom Upload",
  },
  {
    name: "Inventory",
    free: "Public",
    playerPlus: "Hidden option",
    playerUnlimited: "Hidden option",
  },
  {
    name: "Game Intelligence",
    free: "No credits",
    playerPlus: "3 free credits",
    playerUnlimited: "15 free credits",
  },
  {
    name: "Intelligence protection",
    free: "No",
    playerPlus: "No",
    playerUnlimited: "3x Increased cost",
  },
  {
    name: "Can buy credits",
    free: "No",
    playerPlus: "Yes",
    playerUnlimited: "Yes",
  },
  {
    name: "Offense boost",
    free: "No",
    playerPlus: "No",
    playerUnlimited: "5% Boost",
  },
  {
    name: "Defense boost",
    free: "No",
    playerPlus: "No",
    playerUnlimited: "5% Boost",
  },
];

// Helper functions to get feature values
export const getFeatureValue = (
  feature: PremiumFeature,
  tier: "free" | "playerPlus" | "playerUnlimited"
) => {
  return feature[tier];
};

export const isFeatureAvailable = (
  feature: PremiumFeature,
  tier: "free" | "playerPlus" | "playerUnlimited"
): boolean => {
  const value = feature[tier];
  return value !== "No" && value !== 0;
};

export const getFeatureDisplay = (value: string | number): string => {
  if (typeof value === "number") {
    return value.toString();
  }
  return value;
};

// Categories for organizing features
export const FEATURE_CATEGORIES = {
  GAMEPLAY: {
    name: "Gameplay",
    features: ["Clicks per minute", "Worth", "Strenght boost"],
  },
  PROFILE: {
    name: "Profile Customization",
    features: [
      "Profile Avatar",
      "Profile description",
      "Profile background",
      "Custom avatar",
    ],
  },
  SOCIAL: {
    name: "Social & Communication",
    features: ["Messages", "Inventory"],
  },
  PREMIUM: {
    name: "Premium Features",
    features: ["Game Intelligence", "Vault qualified"],
  },
};

export default PREMIUM_FEATURES;
